import { render } from "./parts.vue?vue&type=template&id=3277374d"
import script from "./parts.vue?vue&type=script&lang=js"
export * from "./parts.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/customers/parts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3277374d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3277374d', __exports__)) {
    console.log('reload')
    api.reload('3277374d', __exports__)
  }
  
  module.hot.accept("./parts.vue?vue&type=template&id=3277374d", () => {
    console.log('re-render')
    api.rerender('3277374d', render)
  })

}


export default __exports__